import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query';
import { EnqueueRequest } from '../types/errors';

/**
 * BaseQueryのエラーの有無を返す。
 * @param e EnqueueRequest
 * @returns boolean
 */
export const isFetchBaseQueryError = (
  e: EnqueueRequest
): e is FetchBaseQueryError => {
  // 型検査のために使用するので意図的に ESLint のルールを逸脱する
  // eslint-disable-next-line no-prototype-builtins
  if (e.hasOwnProperty('status') && e.hasOwnProperty('data')) {
    return true;
  }
  return false;
};
